import { css, type SerializedStyles } from '@emotion/react'
import { buttonBaseClasses, touchRippleClasses } from '@mui/material'
import { type Theme } from '@mui/material/styles'
import { rem, size } from 'polished'

import { getFocusVisibleIconButtonStyle } from '@Styles/focus'

const ICON_SIZE = rem(24)

export const container = css({
  alignItems: 'center',
  display: 'flex',
  flex: 1,
})

export const childrenWrapper = (isFullWidth = false): SerializedStyles =>
  css(
    isFullWidth && {
      flex: '0 1 100%',
    },
  )

export const button = (theme: Theme): SerializedStyles =>
  css({
    [`&.${buttonBaseClasses.focusVisible} .${touchRippleClasses.root}`]: {
      opacity: 0,
    },
    '&:focus-visible::before': getFocusVisibleIconButtonStyle(theme.palette.primary.main, rem(7)),
    '&:hover': {
      backgroundColor: 'transparent',
      color: theme.palette.primary.dark,
    },
    color: theme.palette.primary.main,
    flex: `0 1 ${theme.spacing(4)}`,
    margin: `-${theme.spacing(1)} -${theme.spacing(1)} -${theme.spacing(1)} 0`,
    padding: theme.spacing(1),
  })

export const icon = css(size(ICON_SIZE), {
  fill: 'currentcolor',
  flexShrink: 0,
})
